<template>
  <div class="organizational-list">
    <div class="table-header custom-tree-node">
      <span class="name">机构名称</span>
      <span class="status">机构编号</span>
      <span class="status">机构简称</span>
      <span class="status">状态</span>
    </div>
    <el-tree ref="tree" node-key="depCode" :props="props" :load="loadNode" lazy show-checkbox :check-strictly="true" :expand-on-click-node="false" :check-on-click-node="true" :filter-node-method="filterNode" @check-change="handleCheckChange">
      <span class="custom-tree-node" slot-scope="{ node, data }">
        <span class="status">{{ data.name }}</span>
        <span class="status">{{data.depCode}}</span>
        <span class="status">{{data.shortname}}</span>
        <span class="status">
          <el-tag :type="oStateType[data.state]" v-if="data.state !== null">{{oState[data.state]}}</el-tag>
        </span>
      </span>
    </el-tree>
  </div>
</template>
<script>

const oState = {
  1: '启用',
  0: '停用'
};
const oStateType = {
  1: 'success',
  0: 'danger'
};
export default {
  name: 'list',
  props: {
    name: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      oState,
      oStateType,
      props: {
        label: 'name',
        children: 'childRepDepConfigs'
      }
    };
  },
  watch: {
    name(val) {
      this.$refs.tree.filter(val);
    }
  },
  methods: {
    filterNode(value, data) {
      if (!value) return true;
      return data.name.indexOf(value) !== -1;
    },
    handleCheckChange() {
      this.$emit('handleCheckChange', this.$refs.tree.getCheckedNodes());
    },
    loadNode(node, resolve) {
      let _this = this;
      if (node.level === 0) {
        this.$services.post({
          type: 'ORGANIZATIONALMANAGEMENT',
          url: 'getDepartList'
        }).then(res => resolve(res.bean));
      }
      if (node.level > 0) {
        _this.$services.post({
          type: 'ORGANIZATIONALMANAGEMENT',
          url: 'getListAllChildDepAjax',
          params: { depCode: node.data.depCode }
        }).then(res => resolve(res.bean));
      }
    },
    updateKeyChildren(keys, treeData) {
      this.$refs.tree.updateKeyChildren(keys, treeData);
    },
    refresh() {
      this.$refs.tree.setCheckedKeys([]);
    }
  }
};
</script>
<style lang="scss">
.organizational-list {
  width: auto;
  max-height: 500px;
  overflow-y: scroll;
  .table-header {
    height: 48px;
    line-height: 48px;
    text-align: center;
    border-bottom: 1px solid #ebeef5;
    color: #909399;
    font-weight: 600;
    font-size: 14px;

    .name {
      display: inline-block;
      width: calc(100% - 100px);
    }

    .status {
      display: inline-block;
      width: 200px;
    }
  }

  .el-tree {
    font-size: 14px;
    color: #606266;

    .el-tree__empty-block {
      border-bottom: 1px solid #ebeef5;
    }

    .el-tree-node__content {
      height: 61px;
      border-bottom: 1px solid #ebeef5;
    }
  }

  .custom-tree-node {
    flex: 1;
    display: flex;
    align-items: center;
    justify-content: space-between;
    font-size: 14px;

    .status {
      display: inline-block;
      width: 200px;
      text-align: center;
    }

    .name {
      max-width: 268px;
    }
    .default {
      background: transparent;
    }
    .el-treeitem:hover {
      .default {
        background: transparent;
      }
    }
  }
}
</style>
